import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  text?: string;
  subtext?: string;
}

export const LoadingSpinner = ({ 
  size = "md", 
  className, 
  text = "Loading...", 
  subtext 
}: LoadingSpinnerProps) => {
  const spinnerSizes = {
    sm: "h-4 w-4",
    md: "h-8 w-8", 
    lg: "h-12 w-12"
  };

  const textSizes = {
    sm: "text-sm",
    md: "text-lg",
    lg: "text-xl"
  };

  return (
    <div className={cn("flex flex-col items-center justify-center space-y-4", className)}>
      <div className={cn(
        "animate-spin rounded-full border-b-2 border-primary",
        spinnerSizes[size]
      )} />
      {text && (
        <div className="text-center space-y-1">
          <div className={cn("font-medium", textSizes[size])}>{text}</div>
          {subtext && (
            <div className="text-sm text-muted-foreground">{subtext}</div>
          )}
        </div>
      )}
    </div>
  );
};